/**
 * 旧的模型加载方式，不使用统一的 mlib
 * zhongyuliang 2022.03.28
 */

import { baseUrl, getToken } from '@/CommonDP/utils';
import docService from '@/CommonDP/service/doc-service';

export default {
  /**
   * 入口
   * @param { url 数据 } modelUrlData
   * @param { 模型加载参数 } opt
   */
  async load(modelUrlData, opt) {
    this.modelUrlData = modelUrlData;
    this.opt = opt;
    this.resetModelData();

    if (this.modelUrlData.fileObj) {
      // 多文件
      await this.loadMultiModels();
    } else if (this.modelUrlData.fileId) {
      // 单文件
      await this.loadSingleModel();
    }
  },

  resetModelData() {
    this.modeldata = []; // 模型url信息
    this.modeldurlid = []; // 模型信息
    this.picsdata = [];
    this.mapsdata = [];
    this.picdata = '';
  },

  async loadMultiModels() {
    // 多文件
    const modelsarray = this.modelUrlData.fileObj;
    for (let i = 0; modelsarray.length > i; i++) {
      const model = modelsarray[i];
      const rvtId = model.folderID;
      const rvtVersion = model.rvtVersion;
      await this.queryLightFileDownloadUrls(rvtId, rvtVersion);
    }
    this.loadModel();
  },

  async loadSingleModel() {
    // 单个文件
    const rvtId = encodeURIComponent(this.modelUrlData.fileId);
    const rvtVersion = this.modelUrlData.rvtVersion;
    await this.queryLightFileDownloadUrls(rvtId, rvtVersion);
    this.loadModel();
  },

  async queryLightFileDownloadUrls(rvtId, rvtVersion) {
    try {
      const res = await docService.queryModelUrlList(rvtId, rvtVersion);
      const urlarr = res.data || [];
      if (urlarr.length === 0) {
        return;
      }
      for (let j = 0; urlarr.length > j; j++) {
        const lightModel = urlarr[i];
        if (lightModel.fileType == 3) {
          const fileId = lightModel.id;
          const modelurl =
            baseUrl() +
            '/api/v1/doc/unzip-file/preview/' +
            fileId +
            '?token=' +
            getToken() +
            '&fileName=/';
          this.modeldata.push(modelurl);
          this.modeldurlid.push({ modelurl, fileId, rvtId });
        } else if (lightModel.fileType == 2) {
          // 用不到
          if (lightModel.parentID == 'SheetViews') {
            // 用不到
            const picsurl =
              baseUrl() +
              '/api/v1/doc/unzip-file/preview/' +
              lightModel.id +
              '?token=' +
              getToken() +
              '&fileName=/';
            const picName = lightModel.fileName;
            const imgurl =
              baseUrl() +
              '/api/v1/doc/unzip-file/preview//image/' +
              lightModel.id +
              '?token=' +
              getToken();
            const imgid = lightModel.id;
            const paperid = lightModel.paperID;
            this.picsdata.push({
              picName,
              picsurl,
              imgurl,
              imgid,
              modelurl,
              paperid,
            });
          } else if (lightModel.parentID == 'PlaneViews') {
            // 用不到
            const picsurl =
              baseUrl() +
              '/api/v1/doc/unzip-file/preview/' +
              lightModel.id +
              '?token=' +
              token +
              '&fileName=/';
            const picName = lightModel.fileName;
            const imgurl =
              baseUrl() +
              '/api/v1/doc/unzip-file/preview/image/' +
              lightModel.id +
              '?token=' +
              token;
            const imgid = lightModel.id;
            const paperid = lightModel.paperID;
            this.mapsdata.push({
              picName,
              picsurl,
              imgurl,
              imgid,
              modelurl,
              paperid,
            });
          }
        } else if (lightModel.fileType == 1) {
          // 用不到
          const picurl =
            baseUrl() +
            '/api/v1/doc/unzip-file/preview/' +
            lightModel.id +
            '?token=' +
            getToken();
          this.picdata = picurl;
        }
      }
    } catch (error) {
      console.log(error);
    }
  },

  // 加载模型
  loadModel() {
    const models = this.modeldata;
    Monge.EngineResources = './EngineResources';
    Monge.Model.LoadBimx('modelbox', models, this.opt || {});
  },
};
